import React from "react";
import { connect } from "react-redux";
import { useTranslation } from "react-i18next";

function SingleItemPage(props) {
  const { t } = useTranslation();

  // Get product data from props
  const productName = props.data?.order_title || props.order_title || "Varathane Premium Fast Dry Wood Stain Cabernet";
  const productDescription = props.data?.description || "Varathane Premium Fast Dry Wood Stain is an oil-based, durable wood stain that provides a fast-drying finish for interior wood surfaces. This stain penetrates deeply into the wood grain to provide long-lasting protection and rich, even color.";
  const price = props.data?.price_after_discount ? 
    `${props.data.currency} ${props.data.price_after_discount}` : 
    "$24.99";
  
  // Get the first image if available
  const mainImage = props.images?.[0] || null;

  return (
    <div className="image-gallery" style={{ 
      padding: "20px", 
      backgroundColor: "#fff",
      marginBottom: "15px" 
    }}>
      <h6 className={"heading " + (props.language === "en" ? "text-left" : "text-right")} style={{ 
        marginBottom: "20px" 
      }}>
        {t("item-detail.product-image-gallery")}
      </h6>

      {/* Main product display */}
      <div style={{ 
        display: "flex", 
        flexDirection: "row", 
        gap: "20px",
        marginBottom: "20px",
        border: '1px solid #ddd',
        borderRadius: "0px",
        padding: "15px",
        minHeight: "300px"
      }}>
        {/* Left side - Image */}
        <div style={{
          flex: "1",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          padding: "10px",
          backgroundColor: "#fff",
          borderRight: "1px solid #eee"
        }}>
          {mainImage && (
            <img
              src={mainImage.img}
              alt={mainImage.alt || "Product image"}
              style={{
                width: "100%",
                height: "auto",
                objectFit: "contain",
                maxHeight: "250px"
              }}
            />
          )}
        </div>

        {/* Right side - Product info */}
        <div style={{
          flex: "1",
          display: "flex",
          flexDirection: "column",
          justifyContent: "space-between",
          padding: "10px"
        }}>
          <div>
            <h1 style={{ 
              fontSize: "18px", 
              fontWeight: "bold", 
              color: "#333", 
              marginBottom: "15px" 
            }}>
              {productName}
            </h1>
            
            <p style={{ 
              fontSize: "14px", 
              color: "#666", 
              lineHeight: "1.5",
              marginBottom: "20px"
            }}>
              {productDescription}
            </p>
          </div>

          {/* Buttons */}
          <div style={{
            display: "flex",
            flexDirection: "column",
            gap: "10px"
          }}>
            <button style={{
              backgroundColor: "#8B4513",
              color: "white",
              border: "none",
              padding: "12px 20px",
              fontSize: "14px",
              fontWeight: "bold",
              borderRadius: "4px",
              cursor: "pointer",
              textAlign: "center",
              width: "100%"
            }}>
              BUY NOW
            </button>
            
            <button style={{
              backgroundColor: "transparent",
              color: "#8B4513",
              border: "2px solid #8B4513",
              padding: "12px 20px",
              fontSize: "14px",
              fontWeight: "bold",
              borderRadius: "4px",
              cursor: "pointer",
              textAlign: "center",
              width: "100%"
            }}>
              VIEW MORE
            </button>
          </div>
        </div>
      </div>

      {/* Additional images if any */}
      {props.images?.length > 1 && (
        <div style={{ marginTop: "30px" }}>
          <div style={{
            display: "flex",
            gap: "10px",
            width: "100%",
            overflowX: "auto",
            paddingBottom: "10px"
          }}>
            {props.images.slice(1).map((image, index) => (
              <div key={`additional-${index}`} style={{
                flex: "0 0 auto",
                width: "150px",
                height: "150px",
                backgroundColor: "#ffff",
                borderRadius: "8px",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                padding: "0px",
                overflow: "hidden",
                border: "1px solid #ddd"
              }}>
                <img
                  src={image.img}
                  alt={image.alt || `Product image ${index + 2}`}
                  style={{
                    width: "100%",
                    height: "100%",
                    objectFit: "contain"
                  }}
                />
              </div>
            ))}
          </div>
        </div>
      )}

      {props.video && (
        <div className="col-12 p-0" style={{ marginTop: "20px" }}>
          <h6 className="heading">{t("item-detail.product-video")}</h6>
          <div
            className="mb-1 innerhtml video-div"
            dangerouslySetInnerHTML={{ __html: props.video }}
          ></div>
        </div>
      )}
    </div>
  );
}

const mapStateToProps = (state) => ({
  width: state.layout.screenWidth,
  language: state.language.language,
});

export default connect(mapStateToProps, null)(SingleItemPage);